import React from "react";

const TYPE_HEIGHT = {
  text:     14,
  badge:    22,
  action:   28,
  checkbox: 16,
  preview:  40,
};

const TYPE_RADIUS = {
  text:     4,
  badge:    20,
  action:   6,
  checkbox: "50%",
  preview:  6,
};

const TableSkeleton = ({ rows = 8, rowHeight = 42, columns = [] }) => (
  <table style={{ width: "100%", borderCollapse: "collapse" }}>
    <tbody>
      {Array.from({ length: rows }).map((_, i) => (
        <tr key={i} style={{ borderBottom: "1px solid #f0f0f0" }}>
          {columns.map((col, j) => {
            const type = col.type || "text";
            const h = TYPE_HEIGHT[type];
            const vPad = Math.max(0, (rowHeight - h) / 2);
            return (
              <td
                key={j}
                style={{
                  padding: `${vPad}px 16px`,
                  lineHeight: 0,
                  ...(col.minWidth ? { minWidth: col.minWidth } : {}),
                  ...(col.maxWidth ? { maxWidth: col.maxWidth } : {}),
                  ...(col.cellWidth ? { width: col.cellWidth } : {}),
                  textAlign: type === "checkbox" ? "center" : undefined,
                }}
              >
                <div
                  className="contact-skel"
                  style={{
                    height: h,
                    width: col.width,
                    borderRadius: TYPE_RADIUS[type],
                    display: "inline-block",
                  }}
                />
              </td>
            );
          })}
        </tr>
      ))}
    </tbody>
  </table>
);

export default TableSkeleton;
